import { Color } from "../../../maths/Color";
import { Matrix3x3 } from "../../../maths/Matrix3x3";
import { Matrix4x4 } from "../../../maths/Matrix4x4";
import { Vector2 } from "../../../maths/Vector2";
import { Vector3 } from "../../../maths/Vector3";
import { Vector4 } from "../../../maths/Vector4";
import { BaseTexture } from "../../../resource/BaseTexture";
import { NotImplementedError } from "../../../utils/Error";
export var ShaderDataType;
(function (ShaderDataType) {
    ShaderDataType[ShaderDataType["None"] = 0] = "None";
    ShaderDataType[ShaderDataType["Int"] = 1] = "Int";
    ShaderDataType[ShaderDataType["Bool"] = 2] = "Bool";
    ShaderDataType[ShaderDataType["Float"] = 3] = "Float";
    ShaderDataType[ShaderDataType["Vector2"] = 4] = "Vector2";
    ShaderDataType[ShaderDataType["Vector3"] = 5] = "Vector3";
    ShaderDataType[ShaderDataType["Vector4"] = 6] = "Vector4";
    ShaderDataType[ShaderDataType["Color"] = 7] = "Color";
    ShaderDataType[ShaderDataType["Matrix4x4"] = 8] = "Matrix4x4";
    ShaderDataType[ShaderDataType["Texture2D"] = 9] = "Texture2D";
    ShaderDataType[ShaderDataType["Texture3D"] = 10] = "Texture3D";
    ShaderDataType[ShaderDataType["TextureCube"] = 11] = "TextureCube";
    ShaderDataType[ShaderDataType["Buffer"] = 12] = "Buffer";
    ShaderDataType[ShaderDataType["Matrix3x3"] = 13] = "Matrix3x3";
    ShaderDataType[ShaderDataType["Texture2DArray"] = 14] = "Texture2DArray";
})(ShaderDataType || (ShaderDataType = {}));
export function checkShaderDataValueLegal(value, shaderType) {
    let legal = false;
    switch (shaderType) {
        case ShaderDataType.Int:
        case ShaderDataType.Float:
            legal = typeof value == "number";
            break;
        case ShaderDataType.Bool:
            legal = typeof value == "boolean";
            break;
        case ShaderDataType.Vector2:
            legal = value instanceof Vector2;
            break;
        case ShaderDataType.Vector3:
            legal = value instanceof Vector3;
            break;
        case ShaderDataType.Vector4:
            legal = value instanceof Vector4;
            break;
        case ShaderDataType.Color:
            legal = value instanceof Color;
            break;
        case ShaderDataType.Matrix4x4:
            legal = value instanceof Matrix4x4;
            break;
        case ShaderDataType.Texture2D:
            legal = value instanceof BaseTexture;
            break;
        case ShaderDataType.TextureCube:
            legal = value instanceof BaseTexture;
            break;
        case ShaderDataType.Buffer:
            legal = value instanceof ArrayBuffer;
            break;
        case ShaderDataType.Matrix3x3:
            legal = value instanceof Matrix3x3;
            break;
        default:
            legal = false;
            break;
    }
    if (!legal)
        console.warn("The setting value and Shader type do not match");
    return legal;
}
export function ShaderDataDefaultValue(type) {
    switch (type) {
        case ShaderDataType.Int:
            return 0;
        case ShaderDataType.Bool:
            return false;
        case ShaderDataType.Float:
            return 0;
        case ShaderDataType.Vector2:
            return Vector2.ZERO;
        case ShaderDataType.Vector3:
            return Vector3.ZERO;
        case ShaderDataType.Vector4:
            return Vector4.ZERO;
        case ShaderDataType.Color:
            return Color.BLACK;
        case ShaderDataType.Matrix4x4:
            return Matrix4x4.DEFAULT;
        case ShaderDataType.Matrix3x3:
            return Matrix3x3.DEFAULT;
    }
    return null;
}
export class ShaderData {
    constructor(ownerResource = null) {
        this._ownerResource = ownerResource;
    }
    getDefineData() {
        throw new NotImplementedError();
    }
    getData() {
        throw new NotImplementedError();
    }
    addDefine(define) {
        throw new NotImplementedError();
    }
    addDefines(define) {
        throw new NotImplementedError();
    }
    removeDefine(define) {
        throw new NotImplementedError();
    }
    hasDefine(define) {
        throw new NotImplementedError();
    }
    clearDefine() {
        throw new NotImplementedError();
    }
    clearData() {
        throw new NotImplementedError();
    }
    getBool(index) {
        throw new NotImplementedError();
    }
    setBool(index, value) {
        throw new NotImplementedError();
    }
    getInt(index) {
        throw new NotImplementedError();
    }
    setInt(index, value) {
        throw new NotImplementedError();
    }
    getNumber(index) {
        throw new NotImplementedError();
    }
    setNumber(index, value) {
        throw new NotImplementedError();
    }
    getVector2(index) {
        throw new NotImplementedError();
    }
    setVector2(index, value) {
        throw new NotImplementedError();
    }
    getVector3(index) {
        throw new NotImplementedError();
    }
    setVector3(index, value) {
        throw new NotImplementedError();
    }
    getVector(index) {
        throw new NotImplementedError();
    }
    setVector(index, value) {
        throw new NotImplementedError();
    }
    getColor(index) {
        throw new NotImplementedError();
    }
    setColor(index, value) {
        throw new NotImplementedError();
    }
    getMatrix4x4(index) {
        throw new NotImplementedError();
    }
    setMatrix4x4(index, value) {
        throw new NotImplementedError();
    }
    getMatrix3x3(index) {
        throw new NotImplementedError();
    }
    setMatrix3x3(index, value) {
        throw new NotImplementedError();
    }
    getBuffer(index) {
        throw new NotImplementedError();
    }
    setBuffer(index, value) {
        throw new NotImplementedError();
    }
    setTexture(index, value) {
        throw new NotImplementedError();
    }
    getTexture(index) {
        throw new NotImplementedError();
    }
    setShaderData(uniformIndex, type, value) {
        switch (type) {
            case ShaderDataType.Int:
                this.setInt(uniformIndex, value);
                break;
            case ShaderDataType.Bool:
                this.setBool(uniformIndex, value);
                break;
            case ShaderDataType.Float:
                this.setNumber(uniformIndex, value);
                break;
            case ShaderDataType.Vector2:
                this.setVector2(uniformIndex, value);
                break;
            case ShaderDataType.Vector3:
                this.setVector3(uniformIndex, value);
                break;
            case ShaderDataType.Vector4:
                this.setVector(uniformIndex, value);
                break;
            case ShaderDataType.Color:
                this.setColor(uniformIndex, value);
                break;
            case ShaderDataType.Matrix4x4:
                this.setMatrix4x4(uniformIndex, value);
                break;
            case ShaderDataType.Matrix3x3:
                this.setMatrix3x3(uniformIndex, value);
                break;
            case ShaderDataType.Texture2D:
            case ShaderDataType.TextureCube:
                this.setTexture(uniformIndex, value);
                break;
            case ShaderDataType.Buffer:
                this.setBuffer(uniformIndex, value);
                break;
            default:
                throw new Error(`unknown shader data type: ${type}`);
        }
    }
    getShaderData(uniformIndex, type) {
        switch (type) {
            case ShaderDataType.Int:
                return this.getInt(uniformIndex);
            case ShaderDataType.Bool:
                return this.getBool(uniformIndex);
            case ShaderDataType.Float:
                return this.getNumber(uniformIndex);
            case ShaderDataType.Vector2:
                return this.getVector2(uniformIndex);
            case ShaderDataType.Vector3:
                return this.getVector3(uniformIndex);
            case ShaderDataType.Vector4:
                return this.getVector(uniformIndex);
            case ShaderDataType.Color:
                return this.getColor(uniformIndex);
            case ShaderDataType.Texture2D:
            case ShaderDataType.TextureCube:
                return this.getTexture(uniformIndex);
            case ShaderDataType.Buffer:
                return this.getBuffer(uniformIndex);
            case ShaderDataType.Matrix3x3:
                return this.getMatrix3x3(uniformIndex);
            case ShaderDataType.Matrix4x4:
                return this.getMatrix4x4(uniformIndex);
            default:
                throw "unknown shader data type.";
        }
    }
    _setInternalTexture(index, value) {
        throw new NotImplementedError();
    }
    cloneTo(destObject) {
        throw new NotImplementedError();
    }
    clone() {
        throw new NotImplementedError();
    }
    destroy() {
        throw new NotImplementedError();
    }
}
